import React from "react";
import { Button, Table } from "antd";
import { useDeleteResource, useGetResources } from "../../queries/resource";
import ConnectedProviderResourceTable from "./ConnectedProviderResourceTable/ConnectedProviderResourceTable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ResourceTable = () => {
  const { t } = useTranslation();
  const { data: resources } = useGetResources();
  const { mutate: deleteResource } = useDeleteResource();
  const navigate = useNavigate();

  const columns = [
    {
      title: t("pages.resources.resource-table.name"),
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend" as const,
      sorter: (a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name),
    },
    {
      title: t("action"),
      key: "action",
      width: "7rem",
      render: (resource: { id: string }) => (
        <>
          <Button
            type="link"
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/portal/resources/${resource.id}`);
            }}
          >
            {t("pages.resources.resource-table.edit")}
          </Button>
          <Button
            danger
            type="link"
            onClick={(event) => {
              event.stopPropagation();
              deleteResource(resource.id);
            }}
          >
            {t("remove")}
          </Button>
        </>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={resources}
      bordered
      title={() => <strong>{t("pages.resources.resource-table.title")}</strong>}
      style={{ width: "100%" }}
      rowKey={(record) => record.id}
      expandable={{
        expandRowByClick: true,
        expandedRowRender: (record) => (
          <ConnectedProviderResourceTable
            dataSource={record.providerResources}
            resourceId={record.id}
          />
        ),
      }}
    />
  );
};

export default ResourceTable;
